import axios from "axios";

// Same base as customer/user API; path is /api/billing/portal-session
const DEV_API_ROOT = "https://n4kl7g5v9i.execute-api.us-east-1.amazonaws.com/Prod";
const PROD_API_ROOT = "https://customers.api.sagelyn.ai";

const API_ROOT = process.env.REACT_APP_CUSTOMER_API_URL
  ? process.env.REACT_APP_CUSTOMER_API_URL.replace(/customers?\/?$/, "").replace(/\/$/, "")
  : process.env.REACT_APP_ENV === "development"
  ? DEV_API_ROOT
  : PROD_API_ROOT;

const PORTAL_SESSION_URL = `${API_ROOT}/api/billing/portal-session`;

export interface PortalSessionResponse {
  url: string;
}

/**
 * Create a Stripe billing portal session. Returns the URL to redirect the user.
 * 401: not authenticated; 404: no subscription; 500: server error.
 */
export const createPortalSession = async (
  idToken: string
): Promise<PortalSessionResponse> => {
  try {
    const response = await axios.post<PortalSessionResponse>(
      PORTAL_SESSION_URL,
      {},
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        throw new Error("Not authenticated");
      }
      if (error.response.status === 404) {
        throw new Error("No active subscription found");
      }
      if (error.response.status >= 500) {
        throw new Error("Something went wrong, please try again");
      }
    }
    throw error;
  }
};
